"use client";
import React, { Suspense, useEffect, useRef, useState } from "react";
import Link from "next/link";
import Image from "next/image";
import dynamic from "next/dynamic";
import ClickAndShow from "@packages/shared-components/common-utilities/click-show/click-show";
import Getprospectus from "@packages/shared-components/common-utilities/cards/interaction-button/getprospectus";
import Visitwebsite from "@packages/shared-components/common-utilities/cards/interaction-button/visitwebsite";
import BookOpenDay from "@packages/shared-components/common-utilities/cards/interaction-button/bookopenday";
import RequestInfo from "@packages/shared-components/common-utilities/cards/interaction-button/requestinfo";
import ApplyNow from "@packages/shared-components/common-utilities/cards/interaction-button/applynow";
import UserFavourite from "@packages/shared-components/common-utilities/user-favourite/UserFavourite";
import { useSearchParams } from "next/navigation";
import {
  getOrdinalFor,
  getQualCode,
} from "@packages/shared-components/services/utils";
import {
  GA4DataLayer,
  GA4DataLayerFn,
  providerTypeWithSubOrder,
} from "@packages/lib/utlils/helper-function";
import { cleanUniversityUrl } from "@packages/shared-components/services/utils";
const WhatStudentThinkTooltip = dynamic(
  () => import("./what-student-think-tooltip"),
  {
    ssr: false,
  },
);
const WuscaRankingTooltip = dynamic(() => import("./wusca-ranking-tooltip"), {
  ssr: false,
});
import {
  DataLayerGA4AttrType,
  GA4EventAttrType,
} from "@packages/lib/types/datalayerGA";
import { clickstreamForClicks } from "@packages/lib/utlils/commonFunction";
import { ClickstreamInterface } from "@packages/lib/utlils/clickstream";
import {
  ClickstreamConstants,
  GAConstants,
} from "@packages/shared-components/services/constants";
import emitter from "@packages/lib/eventEmitter/eventEmitter";
//import { base64string } from "./base64string";
import ResultSectionSkeleton from "@packages/shared-components/skeleton/search-result/result-section-skeleton";
import { useRouter } from "next/navigation";
import LazyLoadWrapper from "@packages/lib/utlils/lazyloadcomponent";
import { KeyNames } from "@packages/lib/utlils/filters/filterJson";
import { cleanUrl } from "@packages/lib/utlils/url-builder";
import { generateCDPageUrl } from "@packages/lib/utlils/url-builder";
import { getCustomDomain } from "@packages/lib/utlils/common-function-server";
const REVIEW_SPLIT_KEY = "##SPLIT##";
const DetailedReviewLightBox = dynamic(
  () =>
    import("@packages/shared-components/common-utilities/modal/review-lightbox/DetailedReviewLightBox"),
  {
    ssr: false,
  },
);
// const Svgfiles = dynamic(() => import("./svgfiles"), {
//   ssr: false,
// });
interface SrPageResultPodProps {
  searchResultsData: any[];
  qualName: string;
  commonGAAttrs?: GA4EventAttrType;
  collegeCount?: any;
  searchPayLoad?: any;
  courseDisplayName?: any;
  csCommonData?: ClickstreamInterface;
  commonOldGAAttrs?: DataLayerGA4AttrType;
}

const SrPageResultPod: React.FC<SrPageResultPodProps> = ({
  searchResultsData,
  qualName,
  commonGAAttrs,
  collegeCount,
  searchPayLoad,
  courseDisplayName,
  csCommonData,
  commonOldGAAttrs,
}) => {
  const router = useRouter();
  const urlKeyNames = KeyNames();
  const [openedRevieId, setOpenedReviewId] = useState<null | number>(null);
  const searchParams = useSearchParams();
  var csData: ClickstreamInterface = {} as ClickstreamInterface;
  const isWhatuni = process.env.PROJECT === "Whatuni";
  const selectedSubject =
    searchParams?.get(isWhatuni ? "subject" : "course")?.split(" ")[0] ??
    searchParams?.get(isWhatuni ? "subject" : "course") ??
    searchParams?.get(isWhatuni ? "q" : "keyword");

  const universityPodClick = (navigationUrl: any) => {
    window.history.pushState(null, "", cleanUrl(navigationUrl));
    router.push(cleanUrl(navigationUrl));
    // typeof window !== "undefined" && window?.open(navigationUrl, "_self");
  };
  const wuscaClick = (event: React.FormEvent) => {
    event.stopPropagation();
  };
  const calculateDaysBetween = (targetDate: any) => {
    const currentDate: any = new Date();
    const specificDate: any = new Date(targetDate);
    const differenceInTime = specificDate - currentDate;
    const differenceInDays = Math.ceil(
      differenceInTime / (1000 * 60 * 60 * 24),
    );
    return differenceInDays === 1
      ? "Next Open day in " + differenceInDays + " day"
      : differenceInDays < 15
        ? "Next Open day in " + differenceInDays + " days"
        : "";
  };
  const getPRPageURL = (collegeTextKey: any) => {
    const filteredParams = Array.from(searchParams.entries())
      .filter(
        ([key]) =>
          !["sort", "pageno", "page_no", "location", "russell-group"].includes(
            key,
          ),
      )
      .reduce(
        (acc, [key, value]) => {
          acc[key] = value;
          return acc;
        },
        {} as Record<string, string>,
      );
    const queryString = new URLSearchParams(filteredParams).toString();
    const queryParams = queryString ? queryString.split("&") : [];
    queryParams.splice(
      1,
      0,
      `university=${encodeURIComponent(collegeTextKey)}`,
    );
    const newQueryString = queryParams.join("&");
    const baseUrl = isWhatuni ? "/" + qualName + "/csearch" : "/pgs/search";
    const providerResultURL = `${baseUrl}${
      newQueryString ? `?${decodeURIComponent(newQueryString)}` : ""
    }`;
    return providerResultURL;
  };
  const getEnquiryProps = (data: any, courseData: any, index: any) => {
    const baseEnquiryProps = {
      courseId: courseData?.courseId,
      collegeId: data?.hcCollegeId,
      subOrderItemId: courseData?.enquiryDetails?.subOrderItemId,
      sponsoredListingFlag: data?.sponsoredListingFlag,
      manualBoostingFlag: data?.manualBoostingFlag,
      orderItemId: courseData?.enquiryDetails?.orderItemId,
      collegeName: data?.collegeTextKey,
      pageName: "browsemoneypageresults",
      qualCode: isWhatuni ? getQualCode(qualName) : "L",
      selectedSubject: selectedSubject,
      hasRequiredFlags: isWhatuni
        ? courseData?.enquiryDetails?.prospectusFlag !== "Y" &&
          courseData?.enquiryDetails?.websiteFlag !== "Y" &&
          data?.openDayDetails?.opendayFlag !== "Y"
        : courseData?.enquiryDetails?.prospectusFlag !== "Y" &&
          courseData?.enquiryDetails?.websiteFlag !== "Y" &&
          data?.openDayDetails?.opendayFlag !== "Y" &&
          courseData?.enquiryDetails?.applyNowFlag !== "Y",
      ucasPoints: searchPayLoad?.ucasTariffRange,
      featuredListingFlag: "",
      courseName: courseData?.courseTitle,
      collegeDisplayName: data?.collegeDisplayName,
      displayIndex: Number(index) + 1,
      csPageName:
        typeof window !== "undefined"
          ? localStorage.getItem("gaPageName")
          : null,
      studyMode: courseData?.availabilityDetails?.studyMode,
      paginationNumber: searchPayLoad?.pageNo,
    };
    return baseEnquiryProps;
  };
  const hasRequiredFlags = (data: any, courseData: any) => {
    return (
      courseData?.enquiryDetails?.prospectusFlag === "Y" &&
      courseData?.enquiryDetails?.websiteFlag === "Y" &&
      data?.openDayDetails?.opendayFlag === "Y"
    );
  };
  const favouritesData = (data?: any, courseData?: any): GA4EventAttrType => {
    return {
      institution_id: data?.hcCollegeId ?? "",
      institution_name: data?.collegeDisplayName ?? "",
      provider_type:
        data?.sponsoredListingFlag?.toUpperCase() === "Y"
          ? "advertiser"
          : (providerTypeWithSubOrder(
              courseData?.enquiryDetails?.subOrderItemId,
            ) ?? ""),
      course_name: courseData?.courseTitle,
      sponsored:
        data?.sponsoredListingFlag?.toUpperCase() === "Y" ? "Yes" : "NA",
      study_mode: courseData?.availabilityDetails?.studyMode,
      //click_text: linkText || "NA",
      //field: linkText?.includes?.("related courses") ? getCustomDomain() + getPRPageURL(data?.collegeTextKey) : linkText?.includes?.("modules") ? generateCDPageUrl({courseTextKey:courseData.courseTitleTextKey,courseId:courseData.courseId,institutionId:data?.hcCollegeId,institutionTextkey:data.collegeTextKey}) : ""
    };
  };
  const getResultsPodGAAttr = (
    event?: string,
    eventName?: string,
    data?: any,
    courseData?: any,
    linkText?: any,
  ): GA4EventAttrType => {
    return {
      ...commonGAAttrs,
      event: event,
      event_name: eventName,
      institution_id: data?.hcCollegeId ?? "",
      institution_name: data?.collegeDisplayName ?? "",
      provider_type:
        data?.sponsoredListingFlag?.toUpperCase() === "Y"
          ? "advertiser"
          : (providerTypeWithSubOrder(
              courseData?.enquiryDetails?.subOrderItemId,
            ) ?? ""),
      course_name:
        eventName == "course_click" || linkText?.includes?.("modules")
          ? (courseData?.courseTitle ?? "")
          : "",
      sponsored:
        data?.sponsoredListingFlag?.toUpperCase() === "Y" ? "Yes" : "NA",
      study_mode:
        eventName == "course_click"
          ? courseData?.availabilityDetails?.studyMode
          : "NA",
      click_text: linkText || "NA",
      field: linkText?.includes?.("related courses")
        ? getCustomDomain() + getPRPageURL(data?.collegeTextKey)
        : linkText?.includes?.("modules") || linkText?.includes?.("read_more")
          ? generateCDPageUrl({
              courseTextKey: courseData.courseTitleTextKey,
              courseId: courseData.courseId,
              institutionId: data?.hcCollegeId,
              institutionTextkey: data.collegeTextKey,
            })
          : "",
    };
  };
  const getResultsPodOldGAAttr = (
    eventName: string,
    data: any,
    courseData?: any,
  ): DataLayerGA4AttrType => {
    return {
      ...commonOldGAAttrs,
      event: "ga_events",
      eventName: eventName,
      college_id: data?.hcCollegeId ?? "",
      college_name: data?.collegeDisplayName ?? "",
      provider_type:
        data?.sponsoredListingFlag?.toUpperCase() === "Y"
          ? "advertiser"
          : (providerTypeWithSubOrder(
              courseData?.enquiryDetails?.subOrderItemId,
            ) ?? ""),
      course_name:
        eventName != "unilinkclicks" ? (courseData?.courseTitle ?? "") : "",
      sponsored_sr:
        data?.sponsoredListingFlag?.toUpperCase() === "Y" ? "Y" : "none",
      study_mode: courseData?.availabilityDetails?.studyMode,
    };
  };

  const handleGALogs = (
    event: string,
    eventName: string,
    data: any,
    courseData?: any,
    linkText?: any,
  ) => {
    GA4DataLayer(
      getResultsPodGAAttr(event, eventName, data, courseData, linkText),
    );
  };
  const handleOldGALogs = (eventName: string, data: any, courseData?: any) => {
    GA4DataLayerFn(getResultsPodOldGAAttr(eventName, data, courseData));
  };

  const handleReviewLightBox = (event: any, review: string) => {
    event.stopPropagation();
    const reviewId = +review?.split(REVIEW_SPLIT_KEY)[0];
    setOpenedReviewId(() => reviewId);
  };

  const handleReviewClickStream = (
    eventName: string,
    data: any,
    type?: any,
    index?: any,
  ) => {
    csData.eventType = eventName;
    csData.functionalityName = "Reviews";
    csData.actionType = ClickstreamConstants.clickAction;
    csData.CTATitle = type;
    csData.subject = csCommonData?.subject;
    clickstreamForClicks(
      getEnquiryProps(data, "", index),
      csData,
      commonGAAttrs,
      "",
    );
  };
  function addSizeToImagePath(path: string, size: string): string {
    if (path?.toLocaleLowerCase()?.includes("ch")) {
      return path.replace(/\.jpg$/, `_${size}.jpg`);
    }
    return path;
  }

  const isGreaterThanOne = (value: string): boolean => {
    return parseFloat(value) > 1;
  };

  const getCollegeLogoImage = (ipData: any, wuData: any) => {
    return wuData || ipData;
  };

  const viewCourses = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  useEffect(() => {
    if (searchResultsData) {
      emitter.emit("searchresultloading", false);
      const srpageBodySection =
        window.document.getElementById("srpageBodySection");
      srpageBodySection?.classList.remove("hidden");
    }
  }, [searchResultsData]);

  const ViewportTrigger = ({
    data,
    onInView,
    children,
    index,
  }: {
    data: number;
    onInView: (data: number) => void;
    children: React.ReactNode;
    index: number;
  }) => {
    const ref = useRef<HTMLDivElement>(null);
    const hasTriggered = useRef(false);

    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !hasTriggered.current) {
            onInView(data);
            hasTriggered.current = true;
          }
        },
        { threshold: 0.1 },
      );

      if (ref.current) observer.observe(ref.current);
      return () => observer.disconnect();
    }, [data, onInView]);

    return (
      <div className="flex flex-col md:flex-row" ref={ref} key={index + 1}>
        {children}
      </div>
    );
  };

  const trigerTracking = (data: any, displayIndex: number) => {
    GA4DataLayerFn({
      ...commonOldGAAttrs,
      event: "sponsored sr events",
      eventName: "sponsored_sr_impression",
      college_name: data?.collegeDisplayName ?? "",
      college_id: data?.collegeId ?? "",
      provider_type: "advertiser",
      sponsored_sr: "sponsored",
    });
    csData.actionType = ClickstreamConstants.pageViewAction;
    csData.eventType = "Boosted";
    csData.functionalityName = "Sponsor listing";
    clickstreamForClicks(
      getEnquiryProps(
        data,
        data?.[0]?.bestMatchCoursesList?.[0],
        displayIndex + 1,
      ),
      csData,
      commonGAAttrs,
    );
  };

  const favouritesOldData = (
    data?: any,
    courseData?: any,
  ): DataLayerGA4AttrType => {
    return {
      college_id: data?.collegeId ?? "",
      college_name: data?.collegeDisplayName ?? "",
      provider_type:
        data?.sponsoredListingFlag?.toUpperCase() === "Y"
          ? "advertiser"
          : (providerTypeWithSubOrder(
              courseData?.enquiryDetails?.subOrderItemId,
            ) ?? ""),
      course_name: courseData?.courseTitle,
      sponsored_sr:
        data?.sponsoredListingFlag?.toUpperCase() === "Y" ? "Yes" : "NA",
      study_mode: courseData?.availabilityDetails?.studyMode,
      ...commonOldGAAttrs,
      //click_text: linkText || "NA",
      //field: linkText?.includes?.("related courses") ? getCustomDomain() + getPRPageURL(data?.collegeTextKey) : linkText?.includes?.("modules") ? generateCDPageUrl({courseTextKey:courseData.courseTitleTextKey,courseId:courseData.courseId,institutionId:data?.hcCollegeId,institutionTextkey:data.collegeTextKey}) : ""
    };
  };

  const ResultBodyContent = ({
    data,
    displayIndex,
  }: {
    data: any;
    displayIndex: number;
  }) => {
    return (
      <>
        <div
          className="w-full h-[292px] relative bg-grey200 bg-gradient11 shrink-0 rounded-t-[16px] md:rounded-l-[16px] md:rounded-tr-none md:w-[310px] md:h-[316px] lg:w-[500px] lg:h-[376px] cursor-pointer"
          onClick={() => {
            universityPodClick(
              isWhatuni
                ? `/university-profile/${data?.collegeTextKey}${qualName?.includes("postgraduate-courses") ? "/postgraduate" : ""}/${data?.hcCollegeId}/`
                : `/universities/${data?.collegeTextKey}`,
            );
            handleGALogs(GAConstants.track_event, "university_click", data);
            handleOldGALogs("unilinkclicks_chpage", data, "");
          }}
        >
          <div className="absolute top-0 left-0 w-full h-full bg-gradient14 rounded-t-[16px] md:rounded-l-[16px] md:rounded-tr-none"></div>
          <div className="absolute top-0 left-0 p-[16px] w-full h-full bg-gradient14 lg:p-[24px] flex flex-col justify-between rounded-t-[16px] md:rounded-l-[16px] md:rounded-tr-none">
            <div className="flex justify-between">
              <div className="flex items-start gap-[8px]">
                {(data?.collegeMedia?.ipCollegeLogo ||
                  data?.collegeMedia?.wuCollegeLogo ||
                  data?.collegeMedia?.pgsCollegeLogo) && (
                  <a
                    href={
                      isWhatuni
                        ? `/university-profile/${data?.collegeTextKey}/${data?.hcCollegeId}/`
                        : `/universities/${data?.collegeTextKey}`
                    }
                    className="w-[64px] h-[64px] p-[4px] rounded-[4px] bg-white shadow-custom-4"
                  >
                    <Image
                      src={`${process.env.NEXT_PUBLIC_IMAGE_DOMAIN}${getCollegeLogoImage(data?.collegeMedia?.ipCollegeLogo, isWhatuni ? data?.collegeMedia?.wuCollegeLogo : data?.collegeMedia?.pgsCollegeLogo)}`}
                      alt="University logo"
                      fetchPriority={displayIndex < 2 ? "high" : "low"}
                      priority={displayIndex < 2 ? true : false}
                      width={56}
                      height={56}
                      id="uni_img"
                    />
                  </a>
                )}
                {data?.sponsoredListingFlag === "Y" && (
                  <div
                    className="bg-grey-100 text-grey-500 uppercase rounded-[4px] px-[8px] xs-small font-semibold"
                    id="sponsoredSection"
                    data-collegename={data?.collegeDisplayName}
                    data-collegeid={data?.hcCollegeId}
                    data-index={displayIndex}
                  >
                    sponsored
                  </div>
                )}
              </div>
              <UserFavourite
                contentId={data?.hcCollegeId}
                contentName={data?.collegeDisplayName}
                contentType="INSTITUTION"
                statsGAData={favouritesData(data, "")}
                clickStreamData={{
                  ...csCommonData,
                  ...getEnquiryProps(data, "", displayIndex),
                }}
                statsOldGAData={favouritesOldData(data, "")}
              />
            </div>
            <div className="flex flex-col gap-[4px] text-white">
              <a
                href={
                  isWhatuni
                    ? `/university-profile/${data?.collegeTextKey}${qualName?.includes("postgraduate-courses") ? "/postgraduate" : ""}/${data?.hcCollegeId}/`
                    : `/universities/${data?.collegeTextKey}`
                }
              >
                <div className="h5">{data?.collegeDisplayName}</div>
              </a>
              <div className="x-small font-semibold">
                {data?.courseCount}{" "}
                {searchParams?.get(urlKeyNames?.subject)?.includes(" ")
                  ? ""
                  : courseDisplayName?.description}{" "}
                {data?.courseCount === 1 ? "course" : "courses"}
              </div>
              {data?.reviewCount > 0 && (
                <div className="flex items-center gap-[8px] text-grey-50 small">
                  <div className="flex items-center gap-[2px]">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.8586 4.71248C11.2178 3.60691 12.7819 3.60691 13.1412 4.71248L14.4246 8.66264C14.5853 9.15706 15.046 9.49182 15.5659 9.49182H19.7193C20.8818 9.49182 21.3651 10.9794 20.4247 11.6626L17.0645 14.104C16.6439 14.4095 16.4679 14.9512 16.6286 15.4456L17.912 19.3958C18.2713 20.5013 17.0059 21.4207 16.0654 20.7374L12.7052 18.2961C12.2846 17.9905 11.7151 17.9905 11.2945 18.2961L7.93434 20.7374C6.99388 21.4207 5.72851 20.5013 6.08773 19.3958L7.37121 15.4456C7.53186 14.9512 7.35587 14.4095 6.93529 14.104L3.57508 11.6626C2.63463 10.9794 3.11796 9.49182 4.28043 9.49182H8.43387C8.95374 9.49182 9.41448 9.15706 9.57513 8.66264L10.8586 4.71248Z"
                        fill="#0FBEFD"
                      />
                    </svg>
                    {/* <Svgfiles /> */}
                    {data?.exactRating}
                  </div>

                  <a
                    onClick={(event: React.FormEvent) => {
                      event.stopPropagation();
                      handleGALogs(
                        GAConstants.track_event,
                        "review_click",
                        data,
                        "",
                        `${data?.reviewCount} reviews`,
                      );
                      handleReviewClickStream(
                        ClickstreamConstants.readAllReviewClick,
                        data,
                        "",
                        displayIndex,
                      );
                    }}
                    href={
                      isWhatuni
                        ? `/university-course-reviews/${data?.collegeTextKey}/${data?.hcCollegeId}/`
                        : `/${data?.collegeTextKey}/university-reviews.htm`
                    }
                    className="underline"
                  >
                    {data?.reviewCount} reviews
                  </a>
                </div>
              )}
              <div className="flex items-center gap-[4px] font-bold uppercase xs-small">
                {data?.adminVenue && (
                  <div className="bg-grey-100 text-grey-500 px-[8px] rounded-[4px]">
                    {data?.adminVenue}
                  </div>
                )}

                {data?.distanceInMiles > 0 && (
                  <div className="flex items-center justify-center gap-[2px] bg-green-100 text-positive-dark px-[8px] rounded-[4px]">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.929 10.0711C10.5878 10.4122 9.98482 11.0152 9.41426 11.5858C8.63321 12.3668 7.36696 12.3669 6.58591 11.5859C6.02667 11.0266 5.43232 10.4323 5.07111 10.0711C3.45351 8.45346 3.45351 5.83081 5.07111 4.2132C6.68872 2.5956 9.31137 2.5956 10.929 4.2132C12.5466 5.83081 12.5466 8.45346 10.929 10.0711Z"
                        stroke="#168721"
                        strokeWidth="1.13"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M9.55335 7.14214C9.55335 8 8.85791 8.69544 8.00005 8.69544C7.14218 8.69544 6.44675 8 6.44675 7.14214C6.44675 6.28427 7.14218 5.58884 8.00005 5.58884C8.85791 5.58884 9.55335 6.28427 9.55335 7.14214Z"
                        stroke="#168721"
                        strokeWidth="1.13"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    {data?.distanceInMiles} Miles from you
                  </div>
                )}
              </div>
              {isWhatuni && data?.wuscaRanking && (
                <div
                  className="x-small underline w-fit relative group"
                  onClick={(event) => wuscaClick(event)}
                >
                  WUSCA ranking: {data?.wuscaRanking}
                  {getOrdinalFor(data?.wuscaRanking)}
                  <LazyLoadWrapper>
                    <WuscaRankingTooltip />
                  </LazyLoadWrapper>
                </div>
              )}
              {data?.wuscaBadges && isWhatuni && (
                <div className="flex items-center gap-[4px] font-bold uppercase xs-small">
                  <div className="flex items-center gap-[2px] bg-green-100 text-positive-dark px-[8px] rounded-[4px]">
                    <Image
                      src="/static/assets/icons/search-result/lectures-green.svg"
                      alt="Lecturers and Teaching"
                      width={12}
                      height={12}
                    />
                    <span className="line-clamp-1">
                      {data?.wuscaBadges?.includes(",")
                        ? data?.wuscaBadges?.split(",")?.[0]
                        : data?.wuscaBadges}
                    </span>
                  </div>
                  {data?.wuscaBadges?.includes(",") ? (
                    <div className="bg-green-100 text-positive-dark px-[8px] rounded-[4px] shrink-0">
                      + {data?.wuscaBadges?.split(",")?.length - 1} more
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              )}
              {data?.openDayDetails?.openDate &&
              data?.openDayDetails?.opendayFlag === "Y" &&
              isWhatuni ? (
                <div className="flex items-center gap-[4px] font-bold uppercase xs-small">
                  <div className="flex items-center gap-[2px] bg-green-100 text-positive-dark px-[8px] rounded-[4px]">
                    {calculateDaysBetween(data?.openDayDetails?.openDate)}
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
          {(data?.collegeMedia?.ipCollegeImage ||
            data?.collegeMedia?.wuCollegeImage) && (
            <LazyLoadWrapper>
              <Image
                src={`${process.env.NEXT_PUBLIC_IMAGE_DOMAIN}${addSizeToImagePath(getCollegeLogoImage(data?.collegeMedia?.ipCollegeImage, isWhatuni ? data?.collegeMedia?.wuCollegeImage : data?.collegeMedia?.pgsCollegeImage), "567px")}`}
                placeholder="empty"
                fetchPriority={displayIndex < 2 ? "high" : "low"}
                priority={displayIndex < 2 ? true : false}
                alt="University"
                width={529}
                height={376}
                sizes="(max-width: 600px) 100vw, 529px"
                className="w-full h-full rounded-t-[16px] object-cover md:rounded-l-[16px] md:rounded-tr-none"
              />
            </LazyLoadWrapper>
          )}
        </div>
        <div className="flex flex-col grow">
          <div className="bg-white border border-grey-200 rounded-b-[16px] shadow-custom-3 md:rounded-tr-[16px]">
            {isWhatuni && data?.review1Text && (
              <div className="border-b-[1px] border-grey-200 p-[16px] lg:p-[20px]">
                <div className="bg-grey-100 p-[12px] rounded-[8px]">
                  <div className="flex gap-[4px]">
                    <div className="text-[40px] relative font-farro font-normal w-[22px]">
                      <span className="absolute top-[50%]">“</span>
                    </div>
                    <div className="flex flex-col w-full">
                      <div className="relative group x-small">
                        <span className="text-primary-400 underline font-semibold">
                          What students think
                        </span>
                        <LazyLoadWrapper>
                          <WhatStudentThinkTooltip />
                        </LazyLoadWrapper>
                      </div>
                      <div className="relative x-small">
                        <div className="inline text-grey300 line-clamp-2 break-words">
                          {data?.review1Text?.split(REVIEW_SPLIT_KEY)[1]}
                          <div className="inline text-right w-[113px] bg-gradient12">
                            <span>... </span>
                            <button
                              onClick={(e) => {
                                handleReviewLightBox(e, data?.review1Text);
                                handleGALogs(
                                  GAConstants.track_event,
                                  "read_review",
                                  data,
                                  "Read full review",
                                );
                                handleReviewClickStream(
                                  ClickstreamConstants.readFullReviewClick,
                                  data,
                                  "Read full review",
                                  displayIndex,
                                );
                              }}
                              className="text-blue-400 cursor-pointer hover:underline"
                            >
                              Read full review
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {data?.bestMatchCoursesList?.map((courseData: any, index: any) => (
              <div
                className="flex flex-col gap-[16px] border-b-[1px] border-grey-200 p-[16px] lg:p-[20px] last:border-none"
                key={index}
              >
                <div className="flex items-start justify-between">
                  <div className="flex flex-col gap-[8px]">
                    <Link
                      onClick={() => {
                        handleGALogs(
                          GAConstants.track_event,
                          "course_click",
                          data,
                          courseData,
                        );
                      }}
                      href={
                        isWhatuni
                          ? `/degrees/${courseData?.courseTitleTextKey}/${data?.collegeTextKey}/cd/${courseData?.courseId}/${data?.hcCollegeId}`
                          : `/courses/search/postgraduate/${data?.collegeTextKey}/${courseData?.courseTitleTextKey}/${courseData?.courseId}`
                      }
                    >
                      <div className="text-primary-400 font-semibold cursor-pointer hover:underline">
                        {courseData?.courseTitle}
                      </div>
                    </Link>
                    <div className="flex gap-[4px] text-grey-500">
                      {((courseData?.minUcasPoints ||
                        courseData?.maxUcasPoints) &&
                        isWhatuni) ||
                      (courseData?.availabilityDetails?.fees &&
                        isGreaterThanOne(
                          courseData?.availabilityDetails?.fees,
                        ) &&
                        !isWhatuni) ? (
                        <div className="flex items-center justify-center uppercase gap-[2px] bg-grey-100 rounded-[4px] px-[8px] xs-small font-semibold">
                          {/* pgs euro icon */}
                          {!isWhatuni &&
                          courseData?.availabilityDetails?.fees ? (
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.66667 6.33333C9.66667 5.71968 9.16921 5.22222 8.55556 5.22222C7.94191 5.22222 7.44444 5.71968 7.44444 6.33333V9.11111C7.44444 9.72476 6.94698 10.2222 6.33333 10.2222H9.66667M6.33333 8H8.55556M13 8C13 10.7614 10.7614 13 8 13C5.23858 13 3 10.7614 3 8C3 5.23858 5.23858 3 8 3C10.7614 3 13 5.23858 13 8Z"
                                stroke="#5C656E"
                                strokeWidth="1.13"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          ) : (
                            <>
                              {isWhatuni && (
                                <Image
                                  className="hidden md:block"
                                  src="/static/assets/icons/search-result/calender-grey.svg"
                                  alt="Lecturers and Teaching"
                                  width={16}
                                  height={16}
                                />
                              )}
                            </>
                          )}
                          {/* pgs euro icon */}
                          {!isWhatuni
                            ? courseData?.availabilityDetails?.fees
                            : (courseData?.minUcasPoints &&
                              courseData?.maxUcasPoints
                                ? courseData?.minUcasPoints +
                                  "-" +
                                  courseData?.maxUcasPoints
                                : courseData?.minUcasPoints
                                  ? courseData?.minUcasPoints
                                  : courseData?.maxUcasPoints) + " ucas points"}
                        </div>
                      ) : (
                        <></>
                      )}
                      {(courseData?.availabilityDetails?.duration ||
                        courseData?.availabilityDetails?.studyMode) && (
                        <div className="flex items-center justify-center uppercase gap-[2px] bg-grey-100 rounded-[4px] px-[8px] xs-small font-semibold">
                          <Image
                            className="hidden md:block"
                            src="/static/assets/icons/search-result/time-grey.svg"
                            alt="Lecturers and Teaching"
                            width={16}
                            height={16}
                          />
                          {courseData?.availabilityDetails?.duration} <> </>
                          {courseData?.availabilityDetails?.studyMode}
                        </div>
                      )}
                    </div>
                  </div>
                  <UserFavourite
                    contentId={courseData?.courseId}
                    contentName={courseData?.courseTitle}
                    contentType="COURSE"
                    statsGAData={favouritesData(data, courseData)}
                    clickStreamData={{
                      ...csCommonData,
                      ...getEnquiryProps(data, courseData, displayIndex),
                    }}
                    statsOldGAData={favouritesOldData(data, "")}
                  />
                </div>
                {/* pgs descrption */}
                {!isWhatuni && courseData?.courseSummary ? (
                  <div className="relative">
                    <div className="rtf-sr text-grey500 line-clamp-2 small">
                      {courseData?.courseSummary}
                    </div>
                    <div className="absolute bg-gradient13 bg-white bottom-0 right-0 sm:left-[210px]">
                      <span>... </span>
                      <Link
                        onClick={() =>
                          handleGALogs(
                            GAConstants.track_event,
                            "redirection_link_click",
                            data,
                            courseData,
                            "read_more",
                          )
                        }
                        href={`/courses/search/postgraduate/${data?.collegeTextKey}/${courseData?.courseTitleTextKey}/${courseData?.courseId}`}
                        className="text-blue-400 cursor-pointer small hover:underline"
                      >
                        Read More
                      </Link>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
                {/* pgs descrption */}

                {isWhatuni && courseData?.modulesDesc ? (
                  <ClickAndShow>
                    <div className="text-black x-small">
                      <div className="font-semibold">
                        {courseData?.modulesInfo}
                      </div>
                      <ul className="list-disc pl-[20px] flex flex-col gap-[4px]">
                        {courseData?.modulesDesc
                          ?.split("###")
                          .map((desc: any, index: any) => (
                            <li key={index}>{desc}</li>
                          ))}
                      </ul>
                      <Link
                        href={`/degrees/${courseData?.courseTitleTextKey}/${data?.collegeTextKey}/cd/${courseData?.courseId}/${data?.hcCollegeId}`}
                        className="flex items-center gap-[4px] w-fit mt-[4px] text-primary-400 small font-semibold hover:underline"
                      >
                        View all modules
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M8.23441 2.63471C8.54683 2.32229 9.05336 2.32229 9.36578 2.63471L14.1658 7.43471C14.4782 7.74713 14.4782 8.25366 14.1658 8.56608L9.36578 13.3661C9.05336 13.6785 8.54683 13.6785 8.23441 13.3661C7.92199 13.0537 7.92199 12.5471 8.23441 12.2347L11.6687 8.80039L2.4001 8.80039C1.95827 8.80039 1.6001 8.44222 1.6001 8.00039C1.6001 7.55856 1.95827 7.20039 2.4001 7.20039H11.6687L8.23441 3.76608C7.92199 3.45366 7.92199 2.94712 8.23441 2.63471Z"
                            fill="#3460DC"
                          />
                        </svg>
                      </Link>
                    </div>
                  </ClickAndShow>
                ) : (
                  <></>
                )}

                <div
                  className={`grid grid-cols-1 justify-items-stretch gap-[8px] auto-cols-fr xl:grid-rows-1 xl:grid-flow-col ${
                    (!isWhatuni &&
                      courseData?.enquiryDetails?.applyNowFlag === "Y" &&
                      hasRequiredFlags(data, courseData)) ||
                    (isWhatuni && hasRequiredFlags(data, courseData))
                      ? "lg:grid-rows-2 lg:grid-flow-col"
                      : "lg:grid-cols-1"
                  }`}
                >
                  {!isWhatuni &&
                    courseData?.enquiryDetails?.applyNowFlag === "Y" && (
                      <ApplyNow
                        enquiryProps={getEnquiryProps(
                          data,
                          courseData,
                          displayIndex,
                        )}
                        commonGAAttrs={commonGAAttrs}
                        commonOldGAAttrs={commonOldGAAttrs}
                      />
                    )}
                  {courseData?.enquiryDetails?.prospectusFlag === "Y" && (
                    <Getprospectus
                      enquiryProps={getEnquiryProps(
                        data,
                        courseData,
                        displayIndex,
                      )}
                      commonGAAttrs={commonGAAttrs}
                      commonOldGAAttrs={commonOldGAAttrs}
                    />
                  )}
                  {courseData?.enquiryDetails?.websiteFlag === "Y" && (
                    <Visitwebsite
                      enquiryProps={getEnquiryProps(
                        data,
                        courseData,
                        displayIndex,
                      )}
                      commonGAAttrs={commonGAAttrs}
                      commonOldGAAttrs={commonOldGAAttrs}
                    />
                  )}
                  {data?.openDayDetails?.opendayFlag === "Y" && (
                    <BookOpenDay
                      enquiryProps={getEnquiryProps(
                        data,
                        courseData,
                        displayIndex,
                      )}
                      commonGAAttrs={commonGAAttrs}
                      commonOldGAAttrs={commonOldGAAttrs}
                    />
                  )}
                  {(courseData?.enquiryDetails?.subOrderItemId
                    ? courseData?.enquiryDetails?.emailFlag === "Y" // Advertiser: only if email enabled
                    : true) && ( // Non-advertiser: always show
                    <RequestInfo
                      enquiryProps={getEnquiryProps(
                        data,
                        courseData,
                        displayIndex,
                      )}
                      commonGAAttrs={commonGAAttrs}
                      commonOldGAAttrs={commonOldGAAttrs}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
          {data?.courseCount > 2 && (
            <>
              <Link
                href={cleanUniversityUrl(getPRPageURL(data?.collegeTextKey))}
                className="hidden"
              ></Link>
              <div
                tabIndex={0}
                onClick={(event) => {
                  window.history.pushState(
                    null,
                    "",
                    cleanUniversityUrl(getPRPageURL(data?.collegeTextKey)),
                  );
                  emitter.emit("refreshFilters");
                  handleGALogs(
                    GAConstants.track_event,
                    "redirection_link_click",
                    data,
                    "",
                    `View ${data?.courseCount - 2} related ${data?.courseCount - 2 > 1 ? "courses" : "course"}`,
                  );
                  viewCourses(event);
                  router.push(
                    cleanUniversityUrl(getPRPageURL(data?.collegeTextKey)),
                  );
                }}
                className="flex items-center mx-auto gap-[4px] text-primary-400 small font-semibold mt-[16px] cursor-pointer hover:underline"
              >
                View {data?.courseCount - 2} related{" "}
                {data?.courseCount - 2 > 1 ? "courses" : "course"}
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.23798 2.55048C8.55528 2.23317 9.06972 2.23317 9.38702 2.55048L14.262 7.42548C14.5793 7.74278 14.5793 8.25722 14.262 8.57452L9.38702 13.4495C9.06972 13.7668 8.55528 13.7668 8.23798 13.4495C7.92067 13.1322 7.92067 12.6178 8.23798 12.3005L11.726 8.8125L2.3125 8.8125C1.86377 8.8125 1.5 8.44873 1.5 8C1.5 7.55127 1.86377 7.1875 2.3125 7.1875H11.726L8.23798 3.69952C7.92067 3.38222 7.92067 2.86778 8.23798 2.55048Z"
                    fill="#4664DC"
                  />
                </svg>
              </div>
            </>
          )}
        </div>
      </>
    );
  };
  return (
    <Suspense fallback={<ResultSectionSkeleton />}>
      <div
        className={`flex flex-col gap-[16px] md:gap-[24px] ${collegeCount > 10 ? "" : "mb-[24px] md:mb-[40px]"}`}
      >
        {searchResultsData?.map((data, displayIndex) =>
          data?.sponsoredListingFlag === "Y" ? (
            <ViewportTrigger
              key={displayIndex}
              data={4}
              onInView={() => trigerTracking(data, displayIndex)}
              index={displayIndex}
            >
              <ResultBodyContent
                data={data}
                displayIndex={displayIndex}
                key={displayIndex}
              />
            </ViewportTrigger>
          ) : (
            <div className="flex flex-col md:flex-row" key={displayIndex + 1}>
              <ResultBodyContent data={data} displayIndex={displayIndex} />
            </div>
          ),
        )}
      </div>

      {/* <ResultSectionSkeleton/> */}

      {/* {openModal && <SearchResultReviewLightBox onClose={handleCloseModal} />} */}
      {openedRevieId && (
        <DetailedReviewLightBox
          reviewId={openedRevieId}
          closeModal={() => setOpenedReviewId(() => null)}
        />
      )}
    </Suspense>
  );
};

export default SrPageResultPod;
